module.exports = __webpack_public_path__ + "img/Large-2-Bevel-Attachment-27.890db119.png";